<div class="tooltip-container">
  {{ text }}
</div>
